




import Vue from "vue";
import PersonnelChangeDownload from "@/components/personnel-change/personnel-change-download.component.vue";
export default Vue.extend({
  components: {
    "personnel-change-download": PersonnelChangeDownload
  }
});
